import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ActionRole, ButtonType } from '@newroom-connect/library/enums';
import { ListItemType } from '@newroom-connect/library/interfaces';
import { DrawItemPipe, FirstCharOfWordsPipe, ToStringPipe } from '@newroom-connect/library/pipes';

import { MediaPreviewComponent } from '../../media-preview/media-preview.component';

export interface IRowListItemConfiguration {
  type: ListItemType;
  value: unknown;
  additionalInfo?: unknown;
  thumbnailConfig?: {
    backgroundColorClasses?: string[];
    thumbnailSourceKey?: string;
    fallbackThumbnailSourceKey?: string;
    mimetypeKey?: string;
    fallbackMimetypeKey?: string;
  };
  thumbnailSource?: string;
  isHighlighted?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any; // Each type has some more differing properties.
}

@Component({
  standalone: true,
  imports: [
    CommonModule,
    MediaPreviewComponent,
    DrawItemPipe,
    FirstCharOfWordsPipe,
    ToStringPipe
  ],
  selector: 'nrc-collection-permission-list-item',
  templateUrl: './collection-permission-list-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CollectionPermissionListItemComponent {
  @Input({ required: true }) public config!: IRowListItemConfiguration;
  @Input() public isSelected?: boolean;
  @Input() public index?: number;

  @Output() public rowListItemClickedEvent = new EventEmitter();

  public listItemType = ListItemType;
  public buttonType = ButtonType;
  public actionRole = ActionRole;
}
